import { render, staticRenderFns } from "./Input2.vue?vue&type=template&id=2e6a97c4&scoped=true&"
import script from "./Input2.vue?vue&type=script&lang=js&"
export * from "./Input2.vue?vue&type=script&lang=js&"
import style0 from "./Input2.vue?vue&type=style&index=0&id=2e6a97c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a97c4",
  null
  
)

export default component.exports